import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import { usePageDetailsContext } from '@/libraries/contexts/page-details-context/page-details-context';

const loadLoginCurtain = () =>
  import('@/components/organisms/login-curtain/login-curtain');

const LoginCurtain = dynamic(loadLoginCurtain, {
  ssr: false,
});

const LoginCurtainWrapper = () => {
  const { activeModal } = usePageDetailsContext();

  useEffect(() => {
    const preload = () => {
      void loadLoginCurtain();
    };

    const timeoutId = setTimeout(preload, 1000);

    const idleId =
      'requestIdleCallback' in window
        ? window.requestIdleCallback(preload)
        : undefined;

    return () => {
      clearTimeout(timeoutId);

      if (idleId !== undefined) {
        window.cancelIdleCallback(idleId);
      }
    };
  }, []);

  if (activeModal !== 'login') return null;

  return <LoginCurtain />;
};

LoginCurtainWrapper.displayName = 'LoginCurtainWrapper';

export default LoginCurtainWrapper;
